import { type EditorState } from "prosemirror-state";

import { schema } from "@moment/prosemirror-schema";
import { type MappedPresenceIndicator } from "@moment/state";

export function indicatorDisplayableInProseMirror(
	state: EditorState,
	indicator: MappedPresenceIndicator
) {
	const $anchor = state.doc.resolve(indicator.anchor);
	const $head = state.doc.resolve(indicator.head);
	const isInCodeBlock =
		$anchor.node() === $head.node() && $anchor.node().type === schema.nodes.code_block;

	const nodeBefore = $anchor.nodeBefore;
	const nodeAfter = $anchor.nodeAfter;
	const isInComputeCell =
		(nodeBefore && nodeBefore.type === schema.nodes.compute_cell) ||
		(nodeAfter && nodeAfter.type === schema.nodes.compute_cell);

	const result = !isInCodeBlock && !isInComputeCell;
	return result;
}
